export const GET_PM_TERM = 'GET_PM_TERM'
export const GET_PM_TERMS = 'GET_PM_TERMS'
export const SET_PM_TERM = 'SET_PM_TERM'
export const SET_PM_TERM_ERROR = 'SET_PM_TERM_ERROR'
export const SET_PM_TERM_PROCESSING = 'SET_PM_TERM_PROCESSING'

export function getPmTerms (payload) {
  return {
    type: GET_PM_TERMS,
    payload: { ids: payload },
  }
}

export function getPmTerm (payload) {
  return {
    type: GET_PM_TERM,
    payload: { id: payload },
  }
}

export function setPmTerm (data) {
  return {
    type: SET_PM_TERM,
    payload: { data },
  }
}

export function setPmTermError (error) {
  return {
    type: SET_PM_TERM_ERROR,
    payload: { error },
  }
}

export function setPmTermProcessing (id, processing = true) {
  return {
    type: SET_PM_TERM_PROCESSING,
    payload: { id, processing },
  }
}
